import React, { useState } from 'react';
import './PaymentHistory.css';
import { SubscriptionPayment } from './SubscriptionPayment';
import { ZoomPayment } from './ZoomPayment';
import { TestPayment } from './TestPayment';

const filters = [
  { name: 'Subscription', value: 'subscription' },
  { name: 'Live Class', value: 'live_class' },
  { name: 'Test Purchase', value: 'test_purchase' },
];

const PaymentHistory = () => {
  const [activeFilter, setActiveFilter] = useState('subscription');

  return (
    <div className="subscription-container mx-2">
      <div className="filter-section">
        {filters.map((filter) => (
          <button
            key={filter.value}
            className={`filter-button ${activeFilter === filter.value ? 'active' : ''}`}
            onClick={() => setActiveFilter(filter.value)}
          >
            {filter.name}
          </button>
        ))}
      </div>

      {activeFilter === 'subscription' ? (
        <SubscriptionPayment />
      ) : activeFilter === 'live_class' ? (
        <ZoomPayment />
      ) : (
        <TestPayment />
      )}
    </div>
  );
};

export default PaymentHistory;
